import apiClient from '../client';
const ENDPOINT = '/token-types';

export const tokenTypesApi = {
    getList: ({ page = 1, pageSize = 10, sortBy = '-id', filter = {} }) =>
        apiClient.get(ENDPOINT, { params: { page, pageSize, sortBy, filter } }),
    getDetail: (id) => apiClient.get(`${ENDPOINT}/${id}`),
    create: (payload) => apiClient.post(ENDPOINT, payload),
    update: (payload) => apiClient.patch(`${ENDPOINT}/${payload.id}`, payload),
    delete: (id) => apiClient.delete(`${ENDPOINT}/${id}`)
};
